import React from "react";

import { Badge } from "@/components/ui/badge";
import { PaymentStatus } from "@/contexts/TranscribersPaymentsContext.tsx";

function getStatusConfig(status: PaymentStatus) {
    return statusConfig[status.toLowerCase() as PaymentStatus];
}

const statusConfig: Record<PaymentStatus, { variant: "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "info", label: string }> = {
    "draft": { variant: "info", label: 'A venir' },
    "asked": { variant: "warning", label: 'En cours' },
    "paid": { variant: "success", label: 'Payé' },
    "canceled": { variant: "outline", label: 'Annulé' },
    "declined": { variant: "destructive", label: 'Refusé' },
  };

export default function PaymentStatusBadge({ status }: { status: string }) {
  const statusConfig = getStatusConfig(status);

  return (
    <Badge variant={statusConfig.variant}>{statusConfig.label}</Badge>
  );
}